const rem = args => `${parseInt(args, 10) / 16}rem`;
export default rem;
